import { DEAD_ADDRESS, TRANSFER_TOPIC, VITALIK } from "../../integration.js";
import { CORE_PINNED_BLOCK_HASHES, CORE_PINNED_BLOCK_HEIGHTS, CORE_PINNED_TRANSACTION_HASHES } from "../pinned.js";
import { ERC20_BALANCE_OF_REFERENCE_CALLDATA } from "../fixture-inputs.js";
export const MOONBEAM_TEST_CONFIG = {
    balance: { address: VITALIK },
    blockQuery: {
        block: CORE_PINNED_BLOCK_HEIGHTS.moonbeam,
        fixture: "getBlockByNumberMoonbeam",
    },
    balanceQuery: {
        address: VITALIK,
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.moonbeam,
        fixture: "getBalanceMoonbeam",
    },
    tokenBalanceQuery: {
        address: VITALIK,
        // WGLMR — standard wrapped-native contract, live since 2021.
        token: "0xAcc15dC74880C9944775448304B263D191c6077F",
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.moonbeam,
        fixture: "getTokenBalanceMoonbeam",
    },
    blockHashQuery: {
        hash: CORE_PINNED_BLOCK_HASHES.moonbeam,
        fixture: "getBlockByHashMoonbeam",
    },
    blockTransactionsQuery: {
        blockNumber: CORE_PINNED_BLOCK_HEIGHTS.moonbeam,
        fixture: "getBlockTransactionsMoonbeam",
    },
    transfersQuery: {
        address: VITALIK,
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.moonbeam,
        fixture: "getTransfersMoonbeam",
    },
    simulateCallQuery: {
        to: "0xAcc15dC74880C9944775448304B263D191c6077F",
        data: ERC20_BALANCE_OF_REFERENCE_CALLDATA,
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.moonbeam,
        fixture: "simulateCallMoonbeam",
    },
    traceTransactionQuery: {
        hash: CORE_PINNED_TRANSACTION_HASHES.moonbeam,
        fixture: "traceTransactionMoonbeam",
    },
    tokenMetadataQuery: {
        address: "0xAcc15dC74880C9944775448304B263D191c6077F",
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.moonbeam,
        fixture: "getTokenMetadataMoonbeam",
    },
    tokenAllowanceQuery: {
        token: "0xAcc15dC74880C9944775448304B263D191c6077F",
        owner: VITALIK,
        spender: DEAD_ADDRESS,
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.moonbeam,
        fixture: "getTokenAllowanceMoonbeam",
    },
    portfolioQuery: {
        address: VITALIK,
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.moonbeam,
    },
    receiptQuery: {
        hash: CORE_PINNED_TRANSACTION_HASHES.moonbeam,
        fixture: "getReceiptMoonbeam",
    },
    transactionByHashQuery: {
        hash: CORE_PINNED_TRANSACTION_HASHES.moonbeam,
        fixture: "getTransactionByHashMoonbeam",
    },
    estimateGasQuery: {
        to: VITALIK,
        fixture: "estimateGasMoonbeam",
    },
    codeQuery: {
        address: "0xAcc15dC74880C9944775448304B263D191c6077F",
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.moonbeam,
        fixture: "getCodeMoonbeam",
    },
    logsQuery: {
        // Moonbeam WGLMR — 50-block window for log density.
        address: "0xAcc15dC74880C9944775448304B263D191c6077F",
        topic0: TRANSFER_TOPIC,
        fromBlock: String(CORE_PINNED_BLOCK_HEIGHTS.moonbeam - 50),
        toBlock: String(CORE_PINNED_BLOCK_HEIGHTS.moonbeam),
        fixture: "getLogsMoonbeam",
    },
};
